export interface IMarginaliaDeleteDialogData {
  sources?: { label: string; link: string }[];
  citations?: string[];
}
